let jpDate = {};
/*
d : new Date()
*/
jpDate.toJpDate = function(d) {
  var lang = "en";
  let year = d.toLocaleString(lang, { year: "numeric" });
  let month = d.toLocaleString(lang, { month: "numeric" });
  let day = d.toLocaleString(lang, { day: "numeric" });

  return `${year}年${month}月${day}日`;
};

export default jpDate;
